import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Group"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M23.25 22.5H21.75V20.25C21.75 19.0074 20.7426 18 19.5 18H16.5C15.2574 18 14.25 19.0074 14.25 20.25V22.5H12.75V20.25C12.75 18.1789 14.4289 16.5 16.5 16.5H19.5C21.5711 16.5 23.25 18.1789 23.25 20.25V22.5ZM18 9C19.2426 9 20.25 10.0074 20.25 11.25C20.25 12.4926 19.2426 13.5 18 13.5C16.7574 13.5 15.75 12.4926 15.75 11.25C15.75 10.0074 16.7574 9 18 9ZM18 7.5C15.9289 7.5 14.25 9.17893 14.25 11.25C14.25 13.3211 15.9289 15 18 15C20.0711 15 21.75 13.3211 21.75 11.25C21.75 9.17893 20.0711 7.5 18 7.5ZM11.25 16.5H9.75V14.25C9.75 13.0074 8.74264 12 7.5 12H4.5C3.25736 12 2.25 13.0074 2.25 14.25V16.5H0.75V14.25C0.75 12.1789 2.42893 10.5 4.5 10.5H7.5C9.57107 10.5 11.25 12.1789 11.25 14.25V16.5ZM6 3C7.24264 3 8.25 4.00736 8.25 5.25C8.25 6.49264 7.24264 7.5 6 7.5C4.75736 7.5 3.75 6.49264 3.75 5.25C3.75 4.00736 4.75736 3 6 3ZM6 1.5C3.92893 1.5 2.25 3.17893 2.25 5.25C2.25 7.32107 3.92893 9 6 9C8.07107 9 9.75 7.32107 9.75 5.25C9.75 4.25544 9.35491 3.30161 8.65165 2.59835C7.94839 1.89509 6.99456 1.5 6 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Group.vue"]]);
